<template>
  <div class="assinaturas">
    <va-card class="chart-widget" title="Primeiras Assinaturas Ultimos 30 dias">
      <line-chart class="chart" :chart-data="subscriptionsData" :options="options"/>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import LineChart from '../../reports/LineChart.js'
export default {
  name: 'Assinaturas',
  components: { LineChart },
  methods: {
  },
  data () {
    return {
      assinaturas: [],
      subscriptions: [],
      subscriptionsData: [],
      loading: false,
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
        //   enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: 2,
            },
          }],
        },
      },
    }
  },
  apollo: {
    assinaturas: {
      query: gql`
      query MyQuery {
        assinaturas: list_qtd_contract_plan_last_30_days {
          data
          value
        }
      }
      `,
      result ({ data, loading }) {
        const moment = this.$moment
        if (!loading && Object.keys(data).includes('assinaturas')) {
          this.assinaturas = data.assinaturas
          this.subscriptions = data.assinaturas.map(c => {
            return { x: c.data, y: c.value }
          })
          this.subscriptionsData = {
            labels: this.subscriptions.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
            datasets: [
              {
                backgroundColor: '#f2e5e680',
                borderColor: '#943435',
                data: this.subscriptions,
                tension: 0,
              },
            ],
          }
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('assinaturas')) {
      this.$apollo.queries.assinaturas.refetch()
    }
  },
}
</script>

<style lang="scss">
.chart-widget {
  .va-card__body {
    height: 300px;
  }
}

.chart {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    height: 100%;
    width: 100%;
  }

  canvas {
    width: 100%;
    height: auto;
  }
}
</style>
